<template>
  <ReviewsView v-if="reviews && reviews.length > 0" :reviews :subtitle :title />
</template>

<script lang="ts" setup>
import { useAsyncData } from '#imports'

import type { ReviewsProps } from '@backmarket/http-api/src/api-specs-content/models/reviews'
import { getReview } from '@backmarket/http-api/src/api-specs-reviews/reviews'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'

import type { ContentBlockProps } from '../../models/content-block'

import { mapToReviews } from './Reviews.utils'
import ReviewsView from './ReviewsView.vue'

const props = defineProps<ReviewsProps & ContentBlockProps>()

const isFulfilled = <T,>(
  // eslint-disable-next-line no-undef
  input: PromiseSettledResult<T>,
  // eslint-disable-next-line no-undef
): input is PromiseFulfilledResult<T> => input.status === 'fulfilled'

const { data: reviews } = await useAsyncData(async () => {
  const reviewCalls = await Promise.allSettled(
    props.reviewsIds.map((id) =>
      $httpFetch(getReview, { pathParams: { reviewId: id } }),
    ),
  )

  return mapToReviews(reviewCalls.filter(isFulfilled).map((res) => res.value))
})
</script>
